const copy = {
  title: 'Pila — as contas da casa',
  description: 'O mês inteiro da família, sem planilha. Despesas, receitas, quem pagou e o que ainda cabe na renda. Plano Família por R$ 79,90, até cinco pessoas, no Android, no iPhone e no navegador.',
  url: 'https://fontes.business/pila',
  image: 'https://fontes.business/pila/splash.png',
}

function upsert(selector, create, content) {
  let el = document.head.querySelector(selector)
  if (!el) {
    el = create()
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
  return el
}

export function applyPilaHead(page = {}) {
  const title = page.title || copy.title
  const description = page.description || copy.description
  const url = page.url || copy.url
  const image = page.image || copy.image

  document.title = title
  document.documentElement.lang = 'pt-BR'

  upsert('meta[name="description"]', () => {
    const el = document.createElement('meta')
    el.setAttribute('name', 'description')
    return el
  }, description)

  upsert('meta[name="title"]', () => {
    const el = document.createElement('meta')
    el.setAttribute('name', 'title')
    return el
  }, title)

  const tags = [
    ['property', 'og:type', 'website'],
    ['property', 'og:site_name', 'Pila'],
    ['property', 'og:locale', 'pt_BR'],
    ['property', 'og:url', url],
    ['property', 'og:title', title],
    ['property', 'og:description', description],
    ['property', 'og:image', image],
    ['property', 'og:image:secure_url', image],
    ['property', 'og:image:type', 'image/png'],
    ['property', 'og:image:width', '1015'],
    ['property', 'og:image:height', '1001'],
    ['property', 'og:image:alt', 'Pila, as contas da casa'],
    ['name', 'twitter:card', 'summary_large_image'],
    ['name', 'twitter:url', url],
    ['name', 'twitter:title', title],
    ['name', 'twitter:description', description],
    ['name', 'twitter:image', image],
    ['name', 'twitter:image:alt', 'Pila, as contas da casa'],
    ['name', 'theme-color', '#f4efe4'],
  ]

  tags.forEach(([attr, key, content]) => {
    upsert(`meta[${attr}="${key}"]`, () => {
      const el = document.createElement('meta')
      el.setAttribute(attr, key)
      return el
    }, content)
  })

  let canonical = document.head.querySelector('link[rel="canonical"]')
  if (!canonical) {
    canonical = document.createElement('link')
    canonical.setAttribute('rel', 'canonical')
    document.head.appendChild(canonical)
  }
  canonical.setAttribute('href', url)
}
